import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from 'react-transition-group';
import SMSTemplatesCategorySelect from "./SMSTemplatesCategorySelect";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { FormControl } from "react-bootstrap";
import { fetchCompany } from "../actions/index";
import * as Constants from '../constants';
import VideoTemplatesNewInline from "./VideoTemplatesNewInline";

class SMSTemplatesForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    body_text: PropTypes.string.isRequired,
    character_count: PropTypes.string.isRequired,
    sms_template_category_id: PropTypes.number.isRequired,
    categories: PropTypes.array,
    handleSendTestSMS: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    fetchCompany: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    let body_text = this.props.body_text || "";
    this.state = {
      name: this.props.name,
      sms_template_category_id: this.props.sms_template_category_id,
      categories: this.props.categories,
      body_text: body_text,
      character_count: body_text.length,
      errors: {},
      test_sms_number: ""
    };
  }

  componentDidMount() {
    this.props.fetchCompany().then(response => {
      if (response.payload.status == 200) {
        this.setState({ site_domain: response.payload.data.data.site_domain });
      }
    });
  }

  openModalInVideoModal() {
    this.childVideo.openModal();
  }

  handleChangeName(e) {
    this.setState({ name: e.target.value });
  }

  handleChangeBodyText(e) {
    this.setState({
      body_text: e.target.value,
      character_count: e.target.value.length
    });
  }

  handleSelectCategory(sms_template_category_id) {
    this.setState({ sms_template_category_id: sms_template_category_id });
  }

  sendTestSMS() {
    this.validate();
    if (Object.keys(this.state.errors).length == 0) {
      let prms = {
        message: {
          body_text: this.state.body_text
        }
      };
      this.props.handleSendTestSMS(prms);
    }
  }

  validateNotEmpty(fieldName, msg) {
    const value = this.state[fieldName];
    if (value == "" || value == undefined) {
      let newError = {};
      newError[fieldName] = msg;
      this.setState({ errors: Object.assign(this.state.errors, newError) });
    } else {
      let errors = this.state.errors;
      delete errors[fieldName];
      this.setState({ errors: errors });
    }
  }

  validateLength(fieldName, min, max) {
    let newError = {};
    const length = this.state[fieldName].length;
    if (length <= min) {
      newError[fieldName] = "Not enough characters.";
      this.setState({ errors: Object.assign(this.state.errors, newError) });
    } else if (length > max) {
      newError[fieldName] = "Too many characters.";
      this.setState({ errors: Object.assign(this.state.errors, newError) });
    } else {
      let errors = this.state.errors;
      delete errors[fieldName];
      this.setState({ errors: errors });
    }
  }

  handleInsertToken(e) {
    this.setState({ body_text: this.state.body_text + " " + e.target.value });
    e.target.value = "";
  }

  insertVideoLink(thumbnail_url) {
    let link = this.makeVideoLink(thumbnail_url,'3');
    this.setState({ body_text: this.state.body_text + " " + link });
  }

  validateTokens(fieldName, msg) {
    let validTokens = [
      "{{LEAD_NAME}}",
      "{{NAME}}",
      "{{LEAD_FIRST_NAME}}",
      "{{FIRST_NAME}}",
      "{{LEAD_LAST_NAME}}",
      "{{LAST_NAME}}",
      "{{LEAD_LOGIN_LINK}}",
      "{{LEAD_EMAIL}}",
      "{{LEAD_UUID}}",
      "{{EMAIL}}",
      "{{PHONE}}",
      "{{LEAD_AVERAGE_PROPERTY_PRICE}}",
      "{{LEAD_APP_LINK}}",
      "{{SENDER_NAME}}",
      "{{AGENT_NAME}}",
      "{{SENDER_FIRST_NAME}}",
      "{{AGENT_FIRST_NAME}}",
      "{{SENDER_LAST_NAME}}",
      "{{AGENT_LAST_NAME}}",
      "{{SENDER_EMAIL}}",
      "{{AGENT_EMAIL}}",
      "{{SENDER_SIGNATURE}}",
      "{{AGENT_EMAIL_SIGNATURE}}",
      "{{SENDER_PHONE}}",
      "{{AGENT_PHONE}}",
      "{{SENDER_PHONE_OFFICE}}",
      "{{AGENT_PHONE_OFFICE}}",
      "{{SENDER_PHONE_CELL}}",
      "{{AGENT_PHONE_CELL}}",
      "{{SENDER_PHONE_HOME}}",
      "{{AGENT_PHONE_HOME}}",
      "{{LEAD_DOWNLOAD_APP_LINK}}",
      "{{LEAD_LOGIN_HERE_LINK}}",
      "{{LEAD_ADVANCED_SEARCH_LINK}}",
      "{{LEAD_SOLD_SEARCH_LINK}}",
      "{{LEAD_MARKET_REPORT_LINK}}",
      "{{SITE}}",
      "{{DAY_OF_WEEK}}",
      "{{CURRENT_MONTH}}"
    ];
    let value = null;
    value = this.state[fieldName];
    let tokens = value.match(/\{{(.*?)\}}/g);
    let invalidList = [];
    if (tokens) {
      invalidList = tokens.filter(token => {
        if (validTokens.includes(token) == false) {
          return token;
        }
      });
    }
    if (invalidList.length > 0) {
      let newError = {};
      newError[fieldName] = msg;
      this.setState({ errors: Object.assign(this.state.errors, newError) });
    } else {
      let errors = this.state.errors;
      delete errors[fieldName];
      this.setState({ errors: errors });
    }
  }

  validate() {
    this.validateNotEmpty("name", "Please enter a name for your SMS.");
    this.validateNotEmpty(
      "body_text",
      "Please enter a body for your SMS.",
      true
    );
    this.validateLength("body_text", 0, 1024);
    if (this.state.errors.body_text === undefined) {
      this.validateTokens(
        "body_text",
        "The body contains invalid merge fields.",
        true
      );
    }
  }

  save(e) {
    e.preventDefault();
    this.validate();
    if (Object.keys(this.state.errors).length == 0) {
      this.props.handleSubmit(this.state);
    }
  }

  character_count_text_color() {
    if (this.state.character_count <= 140) {
      return "text-success";
    } else if (this.state.character_count <= 1024) {
      return "text-warning";
    } else {
      return "text-danger";
    }
  }

  makeVideoLink(s3_url,duration) {
      let arr = s3_url.split("/");
      let id = arr[arr.length - 1].split('.').slice(-2)[0] ;
      let siteDomain = this.state.site_domain;
      // let durationText = "";
      //
      // if (duration) {
      //   let durArr = duration.split(":");
      //   let durMinutes = parseInt(durArr[0]);
      //   let durSeconds = parseInt(durArr[1]);
      //   if (durMinutes > 0) {
      //     durationText = durMinutes + " minute ";
      //   } else {
      //     durationText = durSeconds + " second ";
      //   }
      // }

      return "Check out this video I made you:\nhttp://" + siteDomain + "/vid/" + id + "?login={{LEAD_UUID}}";
  }

  render() {
    let { id, body_text, name, handleSubmit } = this.props;
    if (!body_text && id) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }
    return (
      <div>

        <VideoTemplatesNewInline
          onRef={ref => (this.childVideo = ref)}
          match={this.props.match}
          location={this.props.location}
          insertVideoLink={this.insertVideoLink.bind(this)}
        />

        <div
          className={`form-group ${this.state.errors.name ? "has-error" : ""}`}
        >
          <label>Name</label>
          <input
            type="text"
            className="form-control name_field"
            onChange={this.handleChangeName.bind(this)}
            value={this.state.name}
          />
          <div className="help-block">{this.state.errors.name}</div>
        </div>

        <div
          className={`form-group ${
            this.state.errors.category_id ? "has-error" : ""
          }`}
        >
          <label>Category</label>
          <SMSTemplatesCategorySelect
            match={this.props.match}
            handleSelectCategory={this.handleSelectCategory.bind(this)}
            categories={this.state.categories}
            sms_template_category_id={this.state.sms_template_category_id}
          />
          <div className="help-block">{this.state.errors.category_id}</div>
        </div>

        <div
          className={`form-group sms_template_body_text ${
            this.state.errors.body_text ? "has-error" : ""
          }`}
        >
          <label>Body</label>
          <select className="fr" onChange={this.handleInsertToken.bind(this)}>
            <option value="">Merge Fields</option>
            <option value="&nbsp;{{NAME}}">Lead - Full Name</option>
            <option value="&nbsp;{{FIRST_NAME}}">Lead - First Name</option>
            <option value="&nbsp;{{LAST_NAME}}">Lead - Last Name</option>
            <option value="&nbsp;{{EMAIL}}">Lead - Email Address</option>
            <option value="&nbsp;{{PHONE}}">Lead - Phone</option>
            <option value="&nbsp;{{LEAD_LOGIN_HERE_LINK}}">Lead - Login Here - Link</option>
            <option value="&nbsp;{{LEAD_AVERAGE_PROPERTY_PRICE}}">
              Lead - Average Property Price
            </option>
            <option value="&nbsp;{{LEAD_APP_LINK}}">
              Lead - App Download Link
            </option>
            <option value="&nbsp;{{AGENT_NAME}}">Agent - Name</option>
            <option value="&nbsp;{{AGENT_FIRST_NAME}}">
              Agent - First Name
            </option>
            <option value="&nbsp;{{AGENT_LAST_NAME}}">
              Agent - Last Name
            </option>
            <option value="&nbsp;{{AGENT_EMAIL}}">
              Agent - Email Address
            </option>
            <option value="&nbsp;{{AGENT_EMAIL_SIGNATURE}}">
              Agent - Email Signature
            </option>
            <option value="&nbsp;{{AGENT_PHONE}}">
              Agent - Direct Phone Number
            </option>
            <option value="&nbsp;{{AGENT_PHONE_OFFICE}}">
              Agent - Office Phone Number
            </option>
            <option value="&nbsp;{{AGENT_PHONE_CELL}}">
              Agent - Cell Phone Number
            </option>
            <option value="&nbsp;{{AGENT_PHONE_HOME}}">
              Agent - Home Phone Number
            </option>
            <option value="&nbsp;{{LEAD_DOWNLOAD_APP_LINK}}">Lead - Download App - Link</option>
            <option value="&nbsp;{{LEAD_ADVANCED_SEARCH_LINK}}">Lead - Advanced Search - Link</option>
            <option value="&nbsp;{{LEAD_SOLD_SEARCH_LINK}}">Lead - Sold Search - Link</option>
            <option value="&nbsp;{{LEAD_MARKET_REPORT_LINK}}">Lead - Market Report - Link</option>
            <option value="&nbsp;{{SITE}}">Site</option>
            <option value="&nbsp;{{DAY_OF_WEEK}}">Day of Week</option>
            <option value="&nbsp;{{CURRENT_MONTH}}">Current Month</option>
          </select>

          <button
            className="btn btn-xs btn-default pull-right m-r-10"
            onClick={this.openModalInVideoModal.bind(this)}>
            Add Video
          </button>

          <textarea
            className="form-control body_text_field"
            onChange={this.handleChangeBodyText.bind(this)}
            value={this.state.body_text}
          />
          <div className="character_count_div">
            Character Count
            <span
              className={`character_count ${this.character_count_text_color()}`}
            >
              {this.state.character_count}
            </span>
            /140
          </div>
          <div className="text-right" style={{ color: "#ccc" }}>
            We recommend less than 140 characters. Maximum allowed characters
            are 1024.
          </div>
          <div className="help-block">{this.state.errors.body_text}</div>
        </div>

        <button className="btn pull-right btn-primary"
         onClick={this.save.bind(this)}>
          Save
        </button>
        <button className="btn pull-right btn-primary m-r-10"
         onClick={this.sendTestSMS.bind(this)}>
          Send Test SMS
        </button>
        <div className="text-right pull-right m-t-5 p-t-3 m-r-10"
          style={{ color: "#ccc" }}>
          Test SMS will be sent to your cell phone number.
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { fetchCompany }
)(SMSTemplatesForm);
